import React from 'react'
import AgTechCard from './AgTechCard'
import AgTechHeaderDetail from '../Headers/AgTechHeaderDetail'
import { AgTechButton } from '../Buttons/AgTechButtons'

export type AgTechSelectableCardProps = {
    header: string,
    detail?: string,
    isSelected: boolean,
    onSelected: () => Promise<void>,
    body?: () => React.ReactNode,
    structure?: {
        height?: number,
        width?: number,
    }
}

const AgTechSelectableCard = (props: AgTechSelectableCardProps) => {
    return (
        <AgTechCard
            structure={props.structure}
            classes={{
                card: `flexed ${props.isSelected ? '!bg-highlight-50' : ''}`
            }}
        >
            <AgTechHeaderDetail
                header={props.header}
                detail={props.detail}
                settings={{
                    content: {
                        body: () => (
                            <div className={`bordered rounded-full w-[16px] h-[16px] centered bg-white flex`}>
                                {props.isSelected && (
                                    <div className='bg-highlight rounded-full w-[10px] h-[10px]' />
                                )}
                            </div>
                        )
                    }
                }}
            />
            {props.body && props.body()}
            <div className='mt-6 wide flex'>
                <AgTechButton
                    text={props.isSelected ? 'Selected' : 'Select'}
                    icon={props.isSelected ? 'fas fa-check' : 'fas fa-check'}
                    action={async e => await props.onSelected()}
                    classes={`ml-auto wide !rounded-lg centered ${props.isSelected ? 'button-highlight' : ''}`}
                />
            </div>
        </AgTechCard>
    )
}

export default AgTechSelectableCard